import { memo } from 'react';
import { CustomTheme } from '../../theme/customTheme';

type Props = {
  size?: number;
  color?: string;
};

function TractIcon({ size = 50, color = CustomTheme.colors.contentPrimary }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 810 809.999993"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="b5150956f3">
          <path
            d="M 362 53.191406 L 442 53.191406 L 442 62 L 362 62 Z M 362 53.191406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6432f09466">
          <path
            d="M 294 272 L 521 272 L 521 756.691406 L 294 756.691406 Z M 294 272 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <path
        fill={color}
        d="M 328.539062 257.617188 L 477.839844 257.617188 L 477.839844 279.175781 L 328.539062 279.175781 L 328.539062 257.617188 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 489.824219 266.078125 C 504.71875 266.578125 507.554688 260.078125 508.230469 248.511719 C 508.910156 236.957031 509.273438 186.976562 507.066406 119.195312 C 505.105469 108.683594 500.203125 94.050781 495.75 79.894531 C 490.058594 61.808594 468.730469 59.261719 453.003906 57.761719 C 441.972656 56.695312 363.863281 57.277344 353.34375 57.761719 C 342.128906 58.25 312.457031 62.476562 306.769531 81.558594 C 303.378906 93.957031 303.246094 110.988281 302.035156 120.425781 C 302.242188 204.003906 301.714844 240.675781 302.035156 252.015625 C 302.382812 264.132812 306.050781 266.109375 316.515625 266.109375 C 356.058594 266.109375 477.480469 265.667969 489.824219 266.078125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 488.992188 115.125 C 491.675781 110.480469 487.65625 106.675781 480.078125 105.390625 C 466.351562 103.0625 439.347656 100.128906 401.03125 100.128906 C 364.015625 100.128906 338.421875 103.34375 325.359375 105.195312 C 318.242188 106.207031 314.742188 108.582031 317.417969 113.429688 C 318.808594 115.953125 330.265625 134.351562 335.527344 142.785156 C 337.121094 145.347656 339.484375 146.988281 343.835938 146.148438 C 348.191406 145.300781 355.652344 141.96875 402.261719 141.96875 C 448.859375 141.96875 461.242188 145.300781 464.242188 146.148438 C 467.261719 146.988281 470.546875 145.433594 472.039062 143.003906 C 476.875 135.097656 487.367188 117.953125 488.992188 115.125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 499.238281 256.03125 L 499.238281 230.378906 L 476.671875 230.378906 C 477.101562 238.265625 477.839844 246.488281 480.847656 251.515625 C 483.855469 256.539062 499.238281 256.03125 499.238281 256.03125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 476.074219 164.976562 C 476.074219 143.875 499.828125 120.425781 499.828125 120.425781 L 499.828125 223.890625 L 476.074219 223.890625 C 476.074219 223.890625 476.074219 186.074219 476.074219 164.976562 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 310.933594 258.863281 L 310.933594 233.21875 L 333.5 233.21875 C 333.070312 241.097656 332.332031 249.324219 329.332031 254.351562 C 326.316406 259.371094 310.933594 258.863281 310.933594 258.863281 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 334.097656 167.808594 C 334.097656 146.707031 310.34375 123.257812 310.34375 123.257812 L 310.34375 226.722656 L 334.097656 226.722656 C 334.097656 226.722656 334.097656 188.90625 334.097656 167.808594 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 272.175781 138.871094 C 272.175781 138.871094 299.617188 132.21875 304.234375 131.058594 C 308.859375 129.898438 300.269531 121.128906 309.882812 120.574219 C 319.507812 120.023438 317.625 112.105469 310.816406 111.890625 C 304.007812 111.671875 278.496094 127.167969 275.332031 131.066406 C 272.175781 134.964844 272.175781 138.871094 272.175781 138.871094 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 537.902344 138.871094 C 537.902344 138.871094 510.464844 132.21875 505.839844 131.058594 C 501.214844 129.898438 509.808594 121.128906 500.1875 120.574219 C 490.570312 120.023438 492.445312 112.105469 499.261719 111.890625 C 506.070312 111.671875 531.574219 127.167969 534.746094 131.066406 C 537.902344 134.964844 537.902344 138.871094 537.902344 138.871094 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill={color}
        d="M 428.027344 143.828125 C 428.128906 142.320312 427.710938 140.761719 426.109375 139.601562 C 421.761719 136.4375 387.988281 136.015625 381.296875 139.601562 C 378.949219 140.863281 378.273438 142.382812 378.34375 143.828125 L 428.027344 143.828125 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 344.304688 64.113281 C 345.285156 68.292969 337.527344 77.273438 330.414062 82.160156 C 322.328125 87.714844 312 94.152344 310.792969 92.183594 C 308.53125 88.511719 315.457031 75.078125 318.769531 72.277344 C 323.214844 68.492188 343.316406 59.933594 344.304688 64.113281 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#ffffff"
        d="M 459.601562 64.113281 C 458.625 68.292969 466.382812 77.273438 473.492188 82.160156 C 481.570312 87.714844 491.902344 94.152344 493.113281 92.183594 C 495.367188 88.511719 488.441406 75.078125 485.128906 72.277344 C 480.683594 68.492188 460.574219 59.933594 459.601562 64.113281 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g clipPath="url(#b5150956f3)">
        <path
          fill={color}
          d="M 441.507812 61.015625 L 362.238281 61.015625 L 362.238281 53.308594 L 441.507812 53.308594 L 441.507812 61.015625 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#6432f09466)">
        <path
          fill={color}
          d="M 520.777344 756.773438 L 294.347656 756.773438 L 294.347656 272.070312 L 520.777344 272.070312 L 520.777344 756.773438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default memo(TractIcon);
